import React from 'react';
import PropTypes from 'prop-types';

import { makeStyles } from '@material-ui/core/styles';

import Grid from '@material-ui/core/Grid';
import InputAdornment from '@material-ui/core/InputAdornment';
import MenuItem from '@material-ui/core/MenuItem';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';

import { BucketIconButton } from '../../../../aws';
import { ResourceRef } from '../../../../resource';
import { fmtDataConfigurationRefs } from '../../../../workload';

const useStyles = makeStyles((theme) => ({
  root: {
    '& .MuiTextField-root': {
      margin: theme.spacing(1),
      width: "100%",
    },
    marginRight: theme.spacing(1),
  },
  grid: {
    flexGrow: 1,
  },  
}));

export default function ChooseDataByPartitionsStep(props) {
  const {
    datasets,
    selectedDataset,
    selectedPrefix,
    selectedStartPartition,
    selectedUntilPartition,
    onDatasetChange,
    onPrefixChange,
    onStartPartitionChange,
    onUntilPartitionChange,
  } = props;
  
  const classes = useStyles();
  
  //const partitionFormats = ['YMDH','N=YMD','Y/M/D/H'] ;
  //const partitionFormat = 'YYYY/MM/DD/HH';

  const handleDatasetChange = (event) => {
    if(onDatasetChange) {
      onDatasetChange(event.target.value);
    }
  };
  
  const handlePrefixChange = (event) => {
    if(onPrefixChange) {
      onPrefixChange(event.target.value);
    }
  };
  
  const handleStartPartitionChange = (event) => {
    if(onStartPartitionChange) {
      onStartPartitionChange(event.target.value);
    }
  };
  
  const handleUntilPartitionChange = (event) => {
    if(onUntilPartitionChange) {
      onUntilPartitionChange(event.target.value);
    }
  };
  
  const selectedDatasetS3Uri = () => {
    const dataset=datasets[selectedDataset];
    return dataset.Location.S3Uri;
  };

  const selectedDatasetRootPrefix = () => {
    const s3uri=selectedDatasetS3Uri();
    if(s3uri) {
      const rootPrefix=s3uri.split('/').slice(3).join('/');
      return(rootPrefix);
    } else {
      return('');
    }
  };

  return (
    <form className={classes.root} noValidate autoComplete="off">
      <Grid container spacing={1}>
        <Grid item xs={12}>
          <Typography color="textSecondary">
            Which partitions from your workload's source data should be used?
          </Typography>
        </Grid>
        <Grid item xs={12}>
          <TextField
            id="selected-dataset" required
            select
            label="Source Dataset"
            value={selectedDataset}
            onChange={handleDatasetChange}
            helperText="Select the source dataset to specify inputs from"
            variant="outlined" size="small"
          >
            {datasets.map((dataset, index) => {
              const refData=fmtDataConfigurationRefs(dataset);
              refData[0].extLink=null;
              return (
                <MenuItem key={dataset.ResourceId} value={index}>
                  <ResourceRef value={refData} type='Dataset' format='qualified' linked={false} />
                </MenuItem>          
              );
            })}
          </TextField>
        </Grid>
        <Grid item xs={12} style={{textAlign: 'center', AlignItems: 'center'}}>
          <TextField
            id="under-prefix"
            label="Under prefix"
            value={selectedPrefix}
            onChange={handlePrefixChange}
            helperText="Process inputs under a specified dataset-relative prefix"
            variant="outlined" size="small"
            InputProps={{
              startAdornment: <InputAdornment position="start">{selectedDatasetRootPrefix()}</InputAdornment>,
              endAdornment:
                <InputAdornment position="end">
                  <BucketIconButton 
                    s3uri={selectedDatasetS3Uri()} 
                    tooltip="View in S3"
                    style={{paddingRight: 0, backgroundColor: 'transparent' }}/>
                </InputAdornment>
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            id="start-partition"
            label="Start partition"
            value={selectedStartPartition}
            onChange={handleStartPartitionChange}
            helperText="Include inputs from but not before"
            variant="outlined" size="small"
          />
        </Grid>
        <Grid item xs={6}>
          <TextField
            id="until-partition"
            label="Until partition"
            value={selectedUntilPartition}
            onChange={handleUntilPartitionChange}
            helperText="Include inputs up to but not on or after"
            variant="outlined" size="small"
          />
        </Grid>
      </Grid>
    </form>
  );
}

ChooseDataByPartitionsStep.propTypes = {
  datasets: PropTypes.array.isRequired,
  selectedDataset: PropTypes.number.isRequired,
  selectedPrefix: PropTypes.string.isRequired,
  selectedStartPartition: PropTypes.string.isRequired,
  selectedUntilPartition: PropTypes.string.isRequired,
  onDatasetChange: PropTypes.func,
  onPrefixChange: PropTypes.func,
  onStartPartitionChange: PropTypes.func,
  onUntilPartitionChange: PropTypes.func,
};

